import { defineComponent as ne, computed as $, provide as T, ref as D, onBeforeMount as le, onMounted as de, watch as B, onUnmounted as ue, useId as ce, createElementBlock as f, openBlock as s, Fragment as Y, createElementVNode as h, createVNode as v, normalizeStyle as me, normalizeClass as fe, unref as r, createCommentVNode as i, withDirectives as ve, createBlock as w, renderSlot as d, normalizeProps as S, guardReactiveProps as b, withCtx as n, vShow as ge, createSlots as pe } from "vue";
import { provideUseId as he } from "@headlessui/vue";
import { OpenApiClientButton as Se } from "@scalar/api-client/components";
import { LAYOUT_SYMBOL as be } from "@scalar/api-client/hooks";
import { WORKSPACE_SYMBOL as ye, ACTIVE_ENTITIES_SYMBOL as we } from "@scalar/api-client/store";
import { addScalarClassesToHeadless as ke, ScalarErrorBoundary as $e, ScalarSidebarFooter as Te, ScalarColorModeToggleButton as Me, ScalarColorModeToggleIcon as Ce } from "@scalar/components";
import { sleep as De } from "@scalar/helpers/testing/sleep";
import { hasObtrusiveScrollbars as Ee, getThemeStyles as Ie } from "@scalar/themes";
import { apiReferenceConfigurationSchema as Le } from "@scalar/types/api-reference";
import { useBreakpoints as Be } from "@scalar/use-hooks/useBreakpoints";
import { useToasts as Oe, ScalarToasts as Re } from "@scalar/use-toasts";
import { useMediaQuery as _e, useResizeObserver as He, useDebounceFn as Ae } from "@vueuse/core";
import Fe from "./ClassicHeader.vue.js";
import Pe from "./GettingStarted.vue.js";
import { hasLazyLoaded as Ne } from "./Lazy/lazyBus.js";
import Ue from "./MobileHeader.vue.js";
import { CONFIGURATION_SYMBOL as Ke } from "../hooks/useConfig.js";
import { useNavState as Ve } from "../hooks/useNavState.js";
import { useLegacyStoreEvents as Ye } from "../v2/hooks/use-legacy-store-events.js";
import { useDocumentSource as ze } from "../features/document-source/hooks/useDocumentSource.js";
import { useSidebar as Ge } from "../features/sidebar/hooks/useSidebar.js";
import { PLUGIN_MANAGER_SYMBOL as Qe } from "../plugins/hooks/usePluginManager.js";
import { createPluginManager as We } from "../plugins/plugin-manager.js";
import je from "../features/sidebar/components/Sidebar.vue.js";
import z from "../features/Search/components/SearchButton.vue.js";
import qe from "./Content/Content.vue.js";
import "./Content/Content.vue2.js";
import Je from "../features/api-client-modal/ApiClientModal.vue.js";
const Xe = ["innerHTML"], Ze = { class: "references-header" }, xe = ["aria-label"], et = { class: "references-navigation-list" }, tt = { key: 0 }, ot = {
  key: 1,
  class: "scalar-api-references-standalone-search"
}, rt = { key: 1 }, at = { class: "references-editor" }, st = { class: "references-editor-textarea" }, it = ["aria-label"], nt = {
  key: 0,
  class: "w-64 *:!p-0 empty:hidden"
}, lt = {
  key: 0,
  class: "references-footer"
}, Ft = /* @__PURE__ */ ne({
  inheritAttrs: !1,
  __name: "ApiReferenceLayout",
  props: {
    configuration: {},
    dereferencedDocument: {},
    originalDocument: {},
    isDark: { type: Boolean },
    rawSpec: {},
    store: {}
  },
  emits: ["changeTheme", "updateContent", "loadSwaggerFile", "linkSwaggerFile", "toggleDarkMode"],
  setup(M) {
    const t = $(
      () => Le.parse(M.configuration)
    ), { initializeToasts: G, toast: Q } = Oe();
    G((e) => Q(e));
    const { dereferencedDocument: g, workspaceStore: O, activeEntitiesStore: R } = ze({
      configuration: t,
      dereferencedDocument: M.dereferencedDocument,
      originalDocument: M.originalDocument
    });
    T(ye, O), T(we, R);
    const W = _e("(min-width: 1150px)"), j = D("100dvh"), y = D(null);
    He(y, (e) => {
      j.value = e[0] ? e[0].contentRect.height + "px" : "100dvh";
    });
    const q = $(Ee), _ = Ve(t), { isSidebarOpen: E, setCollapsedSidebarItem: I, scrollToOperation: J, items: H } = Ge(g, {
      ..._,
      config: t
    }), {
      getReferenceId: X,
      getPathRoutingId: Z,
      getSectionId: x,
      getTagId: ee,
      hash: C,
      isIntersectionEnabled: A,
      updateHash: F,
      replaceUrlState: te
    } = _;
    if (t.value.redirect && typeof window < "u") {
      const e = t.value.redirect(
        (t.value.pathRouting ? window.location.pathname : "") + window.location.hash
      );
      e && history.replaceState({}, "", e);
    }
    le(() => {
      F(), ke();
    });
    const P = async (e) => {
      var o;
      A.value = !1, F(), e ? J(e) : (o = y.value) == null || o.scrollTo(0, 0), await De(100), A.value = !0;
    }, N = D(0);
    de(() => {
      var c, a, p;
      history.scrollRestoration = "manual";
      const e = (a = (c = y.value) == null ? void 0 : c.parentElement) == null ? void 0 : a.getBoundingClientRect(), o = (p = y.value) == null ? void 0 : p.getBoundingClientRect();
      if (e && o) {
        const k = o.top - e.top;
        N.value = k < 2 ? 0 : k;
      }
      window.onhashchange = () => {
        P(X());
      }, window.onpopstate = () => t.value.pathRouting && P(Z(window.location.pathname)), window.addEventListener("scroll", U, { passive: !0 });
    });
    const oe = $(
      () => W.value || !t.value.isEditable
    ), U = Ae(() => {
      window.scrollY < 50 && Ne.value && te("");
    }), re = D(!1);
    B(g, (e) => {
      var o, c;
      if (C.value) {
        const a = x(C.value);
        a && I(a, !0);
      } else if ((o = e.tags) != null && o.length) {
        const a = (c = e.tags) == null ? void 0 : c[0];
        a && I(ee(a), !0);
      } else {
        const a = H.value.entries.find((p) => "tag" in p);
        a && I(a.id, !0);
      }
      re.value = !0;
    });
    const u = $(() => {
      var e;
      return {
        breadcrumb: ((e = H.value) == null ? void 0 : e.titles.get(C.value)) ?? ""
      };
    });
    ue(() => {
      window.removeEventListener("scroll", U);
    }), he(() => ce()), T(be, "modal"), T(Ke, t), T(
      Qe,
      We({
        plugins: t.value.plugins
      })
    );
    const ae = $(
      () => `<style>
  ${Ie(t.value.theme, {
        fonts: t.value.withDefaultFonts
      })}</style>`
    ), { mediaQueries: se } = Be(), ie = !1;
    return B(se.lg, (e, o) => {
      o && !e && (E.value = !1);
    }), B(C, (e, o) => {
      e && e !== o && (E.value = !1);
    }), Ye(M.store, O, R, y), (e, o) => {
      var c, a, p, k, K;
      return s(), f(Y, null, [
        h("div", { innerHTML: ae.value }, null, 8, Xe),
        h("div", {
          ref_key: "documentEl",
          ref: y,
          class: fe(["scalar-app scalar-api-reference references-layout", [
            {
              "scalar-api-references-standalone-mobile": t.value.showSidebar ?? !0,
              "scalar-scrollbars-obtrusive": q.value,
              "references-editable": t.value.isEditable,
              "references-sidebar": t.value.showSidebar,
              "references-sidebar-mobile-open": r(E),
              "references-classic": t.value.layout === "classic"
            },
            e.$attrs.class
          ]]),
          style: me({
            "--scalar-y-offset": `var(--scalar-custom-header-height, ${N.value}px)`
          })
        }, [
          h("div", Ze, [
            t.value.layout === "modern" && (t.value.showSidebar ?? !0) ? (s(), w(Ue, {
              key: 0,
              breadcrumb: u.value.breadcrumb
            }, null, 8, ["breadcrumb"])) : i("", !0),
            d(e.$slots, "header", S(b(u.value)), void 0, !0)
          ]),
          t.value.showSidebar ? (s(), f("aside", {
            key: 0,
            "aria-label": `Sidebar for ${(a = (c = r(g)) == null ? void 0 : c.info) == null ? void 0 : a.title}`,
            class: "references-navigation t-doc__sidebar"
          }, [
            h("div", et, [
              v(r($e), null, {
                default: n(() => {
                  var l, m;
                  return [
                    v(r(je), {
                      title: ((m = (l = r(g)) == null ? void 0 : l.info) == null ? void 0 : m.title) ?? "The OpenAPI Schema"
                    }, {
                      "sidebar-start": n(() => {
                        var L, V;
                        return [
                          e.$slots["document-selector"] ? (s(), f("div", tt, [
                            d(e.$slots, "document-selector", {}, void 0, !0)
                          ])) : i("", !0),
                          t.value.hideSearch ? i("", !0) : (s(), f("div", ot, [
                            v(r(z), {
                              hideModels: (L = t.value) == null ? void 0 : L.hideModels,
                              searchHotKey: (V = t.value) == null ? void 0 : V.searchHotKey
                            }, null, 8, ["hideModels", "searchHotKey"])
                          ])),
                          d(e.$slots, "sidebar-start", S(b(u.value)), void 0, !0)
                        ];
                      }),
                      "sidebar-end": n(() => [
                        d(e.$slots, "sidebar-end", S(b(u.value)), () => [
                          v(r(Te), { class: "darklight-reference" }, {
                            toggle: n(() => [
                              t.value.hideDarkModeToggle ? (s(), f("span", rt)) : (s(), w(r(Me), {
                                key: 0,
                                modelValue: e.isDark,
                                "onUpdate:modelValue": o[0] || (o[0] = (L) => e.$emit("toggleDarkMode"))
                              }, null, 8, ["modelValue"]))
                            ]),
                            default: n(() => [
                              t.value.hideClientButton ? i("", !0) : (s(), w(r(Se), {
                                key: 0,
                                buttonSource: "sidebar",
                                integration: t.value._integration,
                                isDevelopment: ie,
                                url: t.value.url
                              }, null, 8, ["integration", "url"]))
                            ]),
                            _: 1
                          })
                        ], !0)
                      ]),
                      _: 3
                    }, 8, ["title"])
                  ];
                }),
                _: 3
              })
            ])
          ], 8, xe)) : i("", !0),
          ve(h("div", at, [
            h("div", st, [
              d(e.$slots, "editor", S(b(u.value)), void 0, !0)
            ])
          ], 512), [
            [ge, t.value.isEditable]
          ]),
          oe.value ? (s(), f(Y, { key: 1 }, [
            h("main", {
              "aria-label": `Open API Documentation for ${(k = (p = r(g)) == null ? void 0 : p.info) == null ? void 0 : k.title}`,
              class: "references-rendered"
            }, [
              v(r(qe), {
                config: t.value,
                document: r(g),
                store: e.store
              }, pe({
                start: n(() => [
                  d(e.$slots, "content-start", S(b(u.value)), () => [
                    t.value.layout === "classic" ? (s(), w(Fe, { key: 0 }, {
                      "dark-mode-toggle": n(() => [
                        t.value.hideDarkModeToggle ? i("", !0) : (s(), w(r(Ce), {
                          key: 0,
                          class: "text-c-2 hover:text-c-1",
                          mode: e.isDark ? "dark" : "light",
                          style: { transform: "scale(1.4)" },
                          variant: "icon",
                          onClick: o[1] || (o[1] = (l) => e.$emit("toggleDarkMode"))
                        }, null, 8, ["mode"]))
                      ]),
                      default: n(() => {
                        var l;
                        return [
                          e.$slots["document-selector"] ? (s(), f("div", nt, [
                            d(e.$slots, "document-selector", {}, void 0, !0)
                          ])) : i("", !0),
                          t.value.hideSearch ? i("", !0) : (s(), w(r(z), {
                            key: 1,
                            class: "t-doc__sidebar max-w-64",
                            hideModels: (l = t.value) == null ? void 0 : l.hideModels,
                            searchHotKey: t.value.searchHotKey
                          }, null, 8, ["hideModels", "searchHotKey"]))
                        ];
                      }),
                      _: 3
                    })) : i("", !0)
                  ], !0)
                ]),
                end: n(() => [
                  d(e.$slots, "content-end", S(b(u.value)), void 0, !0)
                ]),
                _: 2
              }, [
                (K = t.value) != null && K.isEditable ? {
                  name: "empty-state",
                  fn: n(() => {
                    var l;
                    return [
                      v(Pe, {
                        theme: ((l = t.value) == null ? void 0 : l.theme) || "default",
                        onChangeTheme: o[2] || (o[2] = (m) => e.$emit("changeTheme", m)),
                        onLinkSwaggerFile: o[3] || (o[3] = (m) => e.$emit("linkSwaggerFile")),
                        onLoadSwaggerFile: o[4] || (o[4] = (m) => e.$emit("loadSwaggerFile")),
                        onUpdateContent: o[5] || (o[5] = (m) => e.$emit("updateContent", m))
                      }, null, 8, ["theme"])
                    ];
                  }),
                  key: "0"
                } : void 0
              ]), 1032, ["config", "document", "store"])
            ], 8, it),
            e.$slots.footer ? (s(), f("div", lt, [
              d(e.$slots, "footer", S(b(u.value)), void 0, !0)
            ])) : i("", !0)
          ], 64)) : i("", !0),
          v(r(Je), {
            configuration: t.value,
            dereferencedDocument: r(g)
          }, null, 8, ["configuration", "dereferencedDocument"])
        ], 6),
        v(r(Re))
      ], 64);
    };
  }
});
export {
  Ft as default
};
